import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  InputNumber,
  Radio,
  Row,
  Select,
  TimePicker,
} from "antd";
import { inject, observer } from "mobx-react";
import moment from "moment";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import {
  DATE_FORMAT,
  MANUAL_SCOPE,
  TIME_TO_RUN_REPORT,
  WEEK_DAY_OPTION,
  TRIGGER_TYPE,
} from "utils/constants";
import { TIMEZONES } from "utils/timezone";

const { OptGroup } = Select;
let arrRow = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
let DAY_OF_MONTH = [];
for (let i = 0; i < 3; i++) {
  DAY_OF_MONTH.push(
    <OptGroup key={i}>
      {arrRow.map((e) => {
        let keyId = i * 10 + e;
        return (
          <Select.Option key={keyId}>
            {keyId < 10 ? "0" + keyId : keyId}
          </Select.Option>
        );
      })}
    </OptGroup>
  );
}
DAY_OF_MONTH.push(
  <OptGroup key={111}>
    <Select.Option key={31}>31</Select.Option>
  </OptGroup>
);

const HORIZONTAL_LAYOUT = "horizontal";

@inject("rootStore")
@observer
class ScheduleTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formLayout: HORIZONTAL_LAYOUT,
    };
    this.formItemLayout = {
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
    };
    this.formItemLayoutNoLabel = {
      wrapperCol: { span: 24 },
    };
  }
  componentDidMount() {
    const { childRef } = this.props;
    childRef && childRef(this);
  }
  onChangeTime = (field, value) => {
    this.onChangeField(field, value?.format(DATE_FORMAT.hour));
    return value;
  };
  onChangeDate = (field, value) => {
    this.onChangeField(field, value?.format(DATE_FORMAT.day_only_backend));
    return value;
  };
  onChangeField = (field, value) => {
    const {
      rootStore: {
        analysisScheduleStore: { setFormField },
      },
    } = this.props;
    return setFormField(field, value);
  };
  setFormError = (errors) => {
    errors?.map((e) => {
      const fieldObject = {};
      let fieldName = e.field;
      fieldObject[fieldName] = {
        errors: errors.filter((ei) => ei.field == e.field),
      };
      this.props.form.setFields(fieldObject);
    });
  };
  handleUpdate = () => {
    const {
      rootStore: {
        analysisScheduleStore: {
          getTemplateDetail,
          submitUpdateSchedule,
          formData,
        },
      },
    } = this.props;
    this.props.form.validateFields((err) => {
      if (!err) {
        submitUpdateSchedule(
          () => {
            // history.push("/summary-report/templates");
            getTemplateDetail(formData.general_data.id);
          },
          (error) => {
            this.setFormError(error);
          }
        );
      }
    });
  };

  handleNext = (cb) => {
    this.props.form.validateFields((err) => {
      if (!err) {
        cb();
      }
    });
  };
  renderTimeOfDay = () => {
    const {
      t,
      form: { getFieldDecorator },
      rootStore: {
        analysisScheduleStore: { formData },
      },
    } = this.props;
    const moduleName = "report_template";
    return (
      formData.schedule.scope !== MANUAL_SCOPE && (
        <Form.Item label={t(moduleName + ".time_of_day_label")}>
          {getFieldDecorator("schedule.time", {
            rules: [
              {
                required: !(formData?.schedule?.scope === MANUAL_SCOPE),
                message: t(moduleName + ".time_of_day_required"),
              },
            ],
            initialValue: formData.schedule.time
              ? moment(formData?.schedule.time, DATE_FORMAT.hour)
              : null,
            getValueFromEvent: (e) => {
              return this.onChangeTime("schedule.time", e);
            },
          })(
            <TimePicker
              disabled={formData?.schedule?.scope === MANUAL_SCOPE}
              format={DATE_FORMAT.hour}
            />
          )}
        </Form.Item>
      )
    );
  };
  renderSelectTimeOfDay = () => {
    const {
      t,
      form: { getFieldDecorator },
      rootStore: {
        analysisScheduleStore: { formData },
      },
    } = this.props;
    const moduleName = "report_template";
    switch (formData?.schedule?.scope) {
      case TIME_TO_RUN_REPORT.ONCE: {
        return (
          <Form.Item>
            {getFieldDecorator("schedule.value.date", {
              rules: [
                {
                  required: true,
                  message: t(moduleName + ".schedule_once_required"),
                },
              ],
              initialValue: moment(
                formData?.schedule?.value?.date,
                DATE_FORMAT.day_only_backend
              ),
              getValueFromEvent: (e) => {
                return this.onChangeDate("schedule.value.date", e);
              },
            })(<DatePicker format={DATE_FORMAT.day_only_backend} />)}
          </Form.Item>
        );
      }

      case TIME_TO_RUN_REPORT.EVERY_DAY: {
        return (
          <Form.Item validateStatus="success" help="">
            {getFieldDecorator("schedule.value.offset", {
              rules: [
                {
                  required: true,
                  message: t(moduleName + ".schedule_offset_required"),
                },
              ],
              initialValue: formData?.schedule?.value.offset,
              getValueFromEvent: (e) => {
                return this.onChangeField("schedule.value.offset", e);
              },
            })(<InputNumber min={1} />)}
            {t(moduleName + ".schedule_days_from")}&nbsp;
            {getFieldDecorator("schedule.value.date", {
              rules: [
                {
                  required: true,
                  message: t(moduleName + ".schedule_date_required"),
                },
              ],
              initialValue: moment(
                formData?.schedule?.value.date,
                DATE_FORMAT.day_only_backend
              ),
              getValueFromEvent: (e) => {
                return this.onChangeDate("schedule.value.date", e);
              },
            })(<DatePicker format={DATE_FORMAT.day_only} />)}
          </Form.Item>
        );
      }
      case TIME_TO_RUN_REPORT.DAY_OF_WEEK: {
        return (
          <Form.Item
            className="label"
            label={t(moduleName + ".select_day")}
            {...this.formItemLayout}
            validateStatus="success"
            help=""
          >
            {getFieldDecorator("schedule.value.day_of_week", {
              rules: [
                {
                  required: true,
                  message: t(moduleName + ".week_days_required"),
                },
              ],
              initialValue: formData?.schedule?.value?.day_of_week,
              getValueFromEvent: (e) => {
                return this.onChangeField("schedule.value.day_of_week", e);
              },
            })(<Checkbox.Group options={WEEK_DAY_OPTION} />)}
          </Form.Item>
        );
      }
      case TIME_TO_RUN_REPORT.DAY_OF_MONTH: {
        return (
          <Form.Item validateStatus="success" help="">
            {getFieldDecorator("schedule.value..day_of_month", {
              rules: [
                {
                  required: true,
                  message: t(moduleName + ".schedule_day_month_required"),
                },
              ],
              initialValue: formData?.schedule?.value?.day_of_month,
              getValueFromEvent: (e) => {
                return this.onChangeField("schedule.value.day_of_month", e);
              },
            })(
              <Select
                mode="multiple"
                style={{ width: "680px" }}
                placeholder="Please select"
              >
                {DAY_OF_MONTH}
              </Select>
            )}
          </Form.Item>
        );
      }
    }
  };
  render() {
    const {
      t,
      form: { getFieldDecorator, resetFields },
      rootStore: {
        analysisScheduleStore: { formData, timeValueSelectedOccuring, setTimeValueSelectedOccuring, setOccuringTime },
      },
    } = this.props;
    const moduleName = "report_template";
    return (
      <div className="wrap-alarm-rule-detail-page">
        <Form layout={this.state.formLayout} onSubmit={this.handleSubmit}>
          <div>
            <Row>
              <Col xl={12} xs={24}>
                <Form.Item
                  className="trigger-type-form"
                >
                  <Col fontSize="18px"><b>{t(moduleName + ".trigger_type")}</b></Col>
                  <Radio.Group
                    name="radiogrouptype"
                    value={formData.schedule.scope}
                    onChange={(e) => {
                      this.onChangeField("schedule.scope", e.target.value);
                      setTimeValueSelectedOccuring(e.target.value);
                    }}
                  >
                    <Radio value={TRIGGER_TYPE.manual_trigger}>
                      {t("report_template.manual_trigger")}
                    </Radio>
                    <Radio value={TRIGGER_TYPE.once_time_scheduled_trigger}>
                      {t("report_template.once_time_scheduled_trigger")}
                    </Radio>
                  </Radio.Group>
                  <Radio value={TRIGGER_TYPE.recurring_scheduled_trigger} checked={formData.schedule.scope ===
                    TIME_TO_RUN_REPORT.DAY_OF_MONTH ||
                    formData.schedule.scope ===
                    TIME_TO_RUN_REPORT.DAY_OF_WEEK ||
                    formData.schedule.scope ===
                    TIME_TO_RUN_REPORT.EVERY_DAY || timeValueSelectedOccuring ===
                    TRIGGER_TYPE.recurring_scheduled_trigger ? true : false} onChange={() => {
                      setOccuringTime();
                      this.onChangeField("schedule.scope", TIME_TO_RUN_REPORT.EVERY_DAY);
                    }}>
                    {t("report_template.recurring_scheduled_trigger")}

                  </Radio>
                </Form.Item>
                <Row
                  style={{
                    display:
                      formData.schedule.scope ===
                        TRIGGER_TYPE.once_time_scheduled_trigger
                        ? "inline-block"
                        : "none",
                  }}
                >
                  <Col fontSize="18px"><b>{t(moduleName + ".label_set_trigger_date")}</b></Col>
                  <Form.Item>
                    {getFieldDecorator("schedule.value.date", {
                      rules: [
                        {
                          required: true,
                          message: t(moduleName + ".schedule_once_required"),
                        },
                      ],
                      initialValue: moment(
                        formData?.schedule?.value?.date,
                        DATE_FORMAT.day_only_backend
                      ),
                      getValueFromEvent: (e) => {
                        return this.onChangeDate("schedule.value.date", e);
                      },
                    })(<DatePicker format={DATE_FORMAT.day_only_backend} />)}
                  </Form.Item>
                </Row>
                <Col
                  span={24}
                  className="radio-checked-time"
                  style={{
                    display:
                      (formData.schedule.scope ===
                        TIME_TO_RUN_REPORT.DAY_OF_MONTH ||
                        formData.schedule.scope ===
                        TIME_TO_RUN_REPORT.DAY_OF_WEEK ||
                        formData.schedule.scope ===
                        TIME_TO_RUN_REPORT.EVERY_DAY) ||
                        timeValueSelectedOccuring ===
                        TRIGGER_TYPE.recurring_scheduled_trigger
                        ? "inline-block"
                        : "none",
                  }}
                >
                  <Col fontSize="18px"><b>{t("report_template.set_recurring")}</b></Col>

                  <Row>
                    <Col xl={4}>
                      <Radio.Group
                        defaultValue={TIME_TO_RUN_REPORT.EVERY_DAY}
                        name="radiogroup"
                        value={formData.schedule.scope}
                        onChange={(e) => {
                          this.onChangeField("schedule.scope", e.target.value);
                        }}
                      >
                        <Radio
                          defaultChecked={true}
                          value={TIME_TO_RUN_REPORT.EVERY_DAY}
                          className="radio-recurring"
                        >
                          {t("report_template.EVERY_DAY")}
                        </Radio>
                        <Radio
                          value={TIME_TO_RUN_REPORT.DAY_OF_WEEK}
                          className="radio-recurring"
                        >
                          {t("report_template.DAY_OF_WEEK")}
                        </Radio>
                        <Radio
                          value={TIME_TO_RUN_REPORT.DAY_OF_MONTH}
                          className="radio-recurring"
                        >
                          {t("report_template.DAY_OF_MONTH")}
                        </Radio>
                      </Radio.Group>
                    </Col>
                    <Col xl={20}>
                      <Row className="col-7-every-day">
                        <Form.Item validateStatus="success" help="">
                          {getFieldDecorator("schedule.value.offset", {
                            rules: [
                              {
                                required: true,
                                message: t(
                                  moduleName + ".schedule_offset_required"
                                ),
                              },
                            ],
                            initialValue: formData?.schedule?.value.offset,
                            getValueFromEvent: (e) => {
                              return this.onChangeField(
                                "schedule.value.offset",
                                e
                              );
                            },
                          })(<InputNumber min={1} />)}
                          {t(moduleName + ".schedule_days_from")}&nbsp;
                          {getFieldDecorator("schedule.value.date", {
                            rules: [
                              {
                                required: true,
                                message: t(
                                  moduleName + ".schedule_date_required"
                                ),
                              },
                            ],
                            initialValue: moment(
                              formData?.schedule?.value.date,
                              DATE_FORMAT.day_only_backend
                            ),
                            getValueFromEvent: (e) => {
                              return this.onChangeDate(
                                "schedule.value.date",
                                e
                              );
                            },
                          })(<DatePicker format={DATE_FORMAT.day_only} />)}
                        </Form.Item>
                      </Row>
                      <Row className="col-7-day-of-week">

                        <Form.Item
                          className="label"
                          {...this.formItemLayout}
                          validateStatus="success"
                          help=""
                        >
                          {getFieldDecorator("schedule.value.day_of_week", {
                            rules: [
                              {
                                required: true,
                                message: t(
                                  moduleName + ".week_days_required"
                                ),
                              },
                            ],
                            initialValue:
                              formData?.schedule?.value?.day_of_week,
                            getValueFromEvent: (e) => {
                              return this.onChangeField(
                                "schedule.value.day_of_week",
                                e
                              );
                            },
                          })(<Checkbox.Group options={WEEK_DAY_OPTION} />)}
                        </Form.Item>
                      </Row>
                      <Row className="col-7-day-of-month">

                        <Form.Item validateStatus="success" help="">
                          {getFieldDecorator("schedule.value..day_of_month", {
                            rules: [
                              {
                                required: true,
                                message: t(
                                  moduleName + ".schedule_day_month_required"
                                ),
                              },
                            ],
                            initialValue:
                              formData?.schedule?.value?.day_of_month,
                            getValueFromEvent: (e) => {
                              return this.onChangeField(
                                "schedule.value.day_of_month",
                                e
                              );
                            },
                          })(
                            <Select
                              mode="multiple"
                              style={{ width: "680px" }}
                              placeholder="Please select"
                            >
                              {DAY_OF_MONTH}
                            </Select>
                          )}
                        </Form.Item>
                      </Row>
                      <Button
                        icon="delete"
                        type='primary'
                        onClick={() => {
                          this.onChangeField(
                            "schedule.value.day_of_month",
                            []
                          ),
                          resetFields('schedule.value..day_of_month');
                        }}
                      >
                        {t('report_template.remove_all')}
                      </Button>
                    </Col>
                  </Row>
                </Col>
                <Col
                  style={{
                    display:
                      formData?.schedule?.scope !== TRIGGER_TYPE.manual_trigger
                        ? "inline-block"
                        : "none",
                  }}
                  span={24}
                >
                  {this.renderTimeOfDay()}
                </Col>
              </Col>
              <Col xl={12} xs={24}>
                <Form.Item label="Time zone">
                  <div>
                    {
                      TIMEZONES.find(
                        (e) => e.value === formData.general_data.time_zone
                      ).label
                    }
                  </div>
                </Form.Item>
                <Form.Item label={t("analysis_schedule.receive_email")}>
                  {getFieldDecorator("schedule.mail_receive", {
                    initialValue: formData.schedule.mail_receive,
                    getValueFromEvent: (e) => {
                      return this.onChangeField(
                        "schedule.mail_receive",
                        e.target.checked
                      );
                    },
                  })(
                    <Checkbox checked={formData.schedule.mail_receive}>
                      {t("analysis_schedule.receive_email_checkbox")}
                    </Checkbox>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </div >
        </Form >
      </div >
    );
  }
}

const WrapForm = Form.create({ name: "alarm_rule" })(ScheduleTab);

export default withRouter(withTranslation()(WrapForm));
